var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-76 border"},[(_vm.activetab === 'Templates')?_c('TemplateTab'):(_vm.activetab === 'Text')?_c('TextTab'):(_vm.activetab === 'Media')?_c('MediaTab'):(_vm.activetab === 'Apps')?_c('AppsTab'):(_vm.activetab === 'Stickers')?_c('StickersTab'):(_vm.activetab === 'Settings')?_c('SettingsTab'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }